/* eslint-disable @typescript-eslint/naming-convention */
import { THandleWhiteListed } from '@providers/models'
import { Server } from '@services'

export const handleCheckWhitelisted = async (
    collectionId: string,
    address: string,
    position: number,
): Promise<THandleWhiteListed> => {
    try {
        const response = await Server.get(`/smart/coupon/${collectionId}/${address}/${position}`)
        if (response.data && response.data.data.address.toUpperCase() === address.toUpperCase()) {
            return {
                success: true,
                coupon: response.data.data,
            }
        }
        return {
            success: false,
            error: 'Address not found',
        }
    } catch (error) {
        console.error('[NetworkManager-addressFoundInWhiteList]', error)
        return {
            success: false,
            error: 'Error',
        }
    }
}
